import classnames from 'classnames';
import { CSSProperties, PropsWithChildren } from 'react';

import { getCustomStyle } from '@/app/[locale]/(default-layout)/_components/CustomStyles.tsx';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto.ts';

export default function CardWrapper({
    className,
    children,
    domainConfiguration,
    style
}: PropsWithChildren<{ className?: string; domainConfiguration?: DomainConfigurationDto; style?: CSSProperties }>) {
    const customStyle = getCustomStyle(domainConfiguration);
    return (
        <div
            className={classnames(className)}
            style={{
                backgroundColor: customStyle?.heroBackgroundColor,
                ...style
            }}>
            {children}
        </div>
    );
}
